import React, { useState, useEffect } from 'react';
import { CSVLink } from "react-csv";

import DateFilter from '../../components/DateFilter';

import moment from 'moment';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

import { useHistory } from 'react-router-dom';

import { getDeliveryInfos, getDeliveryInfosByDate } from '../../app.service';

import './dashboard.styles.scss';
import axios from 'axios';

import jsPDF from 'jspdf';
require('jspdf-autotable');


const Dashboard = () => {

    const history = useHistory()

    const [deliveryInfo, setDeliveryInfo] = useState([]);
    const [quickFilter, setQuickFilter] = useState('');



    const columns = [
                {headerName: 'Date', field: 'date' },
                {
                    headerName: 'Action',
                    cellRenderer: 'buttonRenderer',
                    cellRenderer: (params) => {
                        var link = document.createElement('a');
                        link.href = '#';
                        link.innerText = 'View';
                        link.addEventListener('click', (e) => {
                            e.preventDefault();
                            console.log("Selected Store Row", params.data);
                            history.push({
                                pathname: '/delivery',
                                state: { data:params.data }
                            });
                        });
                        return link;
                    }
                },
                {headerName: 'First Name', field: 'firstname'},
                {headerName: 'Last Name', field: 'surname'},
                {headerName: 'Email', field: 'email'},
                {headerName: 'Phone', field:'phone'},
                {headerName: 'Voucher', field: 'voucher'},
                {headerName: 'Address', field: 'streetAddress'},
                {headerName: 'Province', field: 'Province'},
                {headerName: 'Post Code', field:'postCode'},
                {headerName: 'Delivery Details', field:'deliveryDetails'},
                {headerName: 'Dispatched Date', field:'dispatchedDate'},
                {headerName: 'Delivery Date', field:'deliveryDate'},
                {headerName: 'Comments', field:'comment', editable: true}
                
            ]


    useEffect(() => {
        loadData();
    },[])

    const loadData = async (dateRange) => {
        const response = await axios.get(`${getDeliveryInfosByDate()}/${moment().format('YYYY-MM-DD')}/${moment().format('YYYY-MM-DD')}`);
        console.log(response)
        // setDeliveryInfo(response.data)
        // console.log(response.data)
        console.log("date format", response.data.map(x => moment(x.date).format('YYYY-MM-DD h:mm:ss')))
        setDeliveryInfo(response.data.map(x => { 
       const info = {
           "_id": x._id,
           "date":x.date, // moment(x.date).format('YYYY-MM-DD h:mm:ss'),
            "email": x.email, 
            "voucher": x.voucher,        
            "password": x.password,
            "upsSerial": x.upsSerial, 
            "redeemed": x.redeemed=== true ? 'Redeemed' : 'Not Redeemed',       
            "firstname": x.firstname,
            "surname": x.surname, 
            "phone": x.phone,  
            "streetAddress": x.streetAddress,
            "suburb": x.suburb,
            "Province": x.Province,
            "postCode": x.postCode,
            "deliveryDetails": x.deliveryDetails,
            "dispatchedDate": x.dispatchedDate,
            "deliveryDate": x.deliveryDate,
            "comment": x.comment,

       }
       console.log("New Info", info)
       return info

    }))
    }


    const callback = async (dateRange) => {
       console.log("Parent", dateRange)
       const response = await axios.get(`${getDeliveryInfosByDate()}/${dateRange.startDate}/${dateRange.endDate}`);
    //    console.log(response)
       console.log("date format", response.data.map(x => moment(x.date).format('YYYY-MM-DD h:mm:ss')))
      // setDeliveryInfo(response.data.map(x => moment(x.date).format('YYYY-MM-DD h:mm:ss')))

       setDeliveryInfo(response.data.map(x => { 
        const info = {
            "_id": x._id,
            "date": moment(x.date).format('YYYY-MM-DD h:mm:ss'),
             "email": x.email, 
             "voucher": x.voucher,        
             "password": x.password,
             "upsSerial": x.upsSerial, 
             "redeemed": x.redeemed=== true ? 'Redeemed' : 'Not Redeemed',       
             "firstname": x.firstname,
             "surname": x.surname, 
             "phone": x.phone,  
             "streetAddress": x.streetAddress,
             "suburb": x.suburb,
             "Province": x.Province,
             "postCode": x.postCode,
             "deliveryDetails": x.deliveryDetails,
             "dispatchedDate": x.dispatchedDate,
             "deliveryDate": x.deliveryDate,
             "comment": x.comment,
 
        }
        console.log("New Info", info)
        return info
 
     }))
    //    console.log("date format", response.data.map(x => moment(x.date).format('YYYY-MM-DD h:mm:ss')))
        // do something with value in parent component, like save to state
    }

    return(
      
       <div className='dashboard'
                className="ag-theme-balham"
                style={{ height: '600px', width: '100%' }}

                
            >
<div style={{textAlign:'center', margin:"2%"}}>
                <DateFilter parentCallback={callback}/>
            </div>
            <div>
                <center>
                    <CSVLink 
                data={deliveryInfo}
                filename={"Redeemed Vouchers.csv"}
                className="btn btn-primary"
                >CSV</CSVLink></center> 
            </div>
            <br/>

                <AgGridReact
                    defaultColDef={{filter: true}}
                    columnDefs={columns}
                    rowData={deliveryInfo}
                    >
                </AgGridReact>
            </div>
        
    )

}

export default Dashboard;